"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _require = require('lodash'),
  debounce = _require.debounce;
var _require2 = require('src/branded-apps-metadata'),
  TABLES = _require2.TABLES,
  FORMS = _require2.FORMS;
var AppsListCtrl = /* @ngInject */function AppsListCtrl($route, $scope, $sanitize, $q, $filter, userService, modalService, appBrandingService, taskSeriesService, taskExecutorService) {
  var pluralizeIfSeveral = $filter('pluralizeIfSeveral');
  var allBrandings = [];
  var cachedAccounts;
  var cachedBaseApp;
  var searchTerm;
  $scope.canManageApps = userService.hasPermission('app-brandings.manage_apps');
  $scope.canPublishApps = userService.hasPermission('app-brandings.app_publisher');
  $scope.tableConfig = {
    maxSize: 9,
    itemsByPage: 10,
    numberOfItems: 0,
    selectionMode: 'multiple',
    isGlobalSearchActivated: true,
    serverSidePagination: true,
    isPaginationEnabled: true,
    serverSidePaginationOnSearch: true,
    serverSidePageGetter: function serverSidePageGetter() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        skip = _ref.skip,
        search = _ref.search;
      searchTerm = search;
      return loadData({
        skip: skip
      });
    }
  };
  _.each(TABLES.appsList, function (column) {
    return column.formatFunction = $sanitize;
  });
  $scope.columnCollection = TABLES.appsList;
  $scope.filters = {
    maintained: {
      label: 'Is maintained',
      type: 'toggle',
      value: undefined
    }
  };

  // $scope API
  $scope.$watch('rowCollection', function (collection) {
    if (!collection) {
      return;
    }
    return $scope.selectedBrandings = _.where(collection, {
      isSelected: true
    });
  }, true);
  $scope.setFilterValue = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var filter, value, currentValue;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            filter = _ref2.filter, value = _ref2.value;
            currentValue = $scope.filters[filter].value;
            if (!(currentValue === value)) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            $scope.filters[filter].value = value;
            _context.next = 7;
            return loadDataDebounced({
              clear: true
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var currentUsersOrganisations = _.chain(userService.getCurrentUser().orgs)
  // Issue #1203 some orgs doesn't have names
  .map(function (org) {
    return [org._id, org.display_name || 'Unknown'];
  }).sortBy(function (org) {
    return org[1].toLowerCase();
  }).object().value();
  $scope.showAppCreationModal = function () {
    var fields = angular.copy(FORMS.createApp);
    fields.fp_owner.kind_options = {
      values: currentUsersOrganisations
    };
    return modalService.openModalWithForm({
      title: 'Create App',
      saveLabel: 'Create',
      fields: fields,
      formCanBeSaved: function formCanBeSaved(model) {
        return model.springboard_name && model.fp_ext_id && model.fp_owner && appBrandingService.isBrandingIdValid(model.fp_ext_id);
      }
    }).then(function (model) {
      // Default store name = app name
      model.store_config = {
        name: model.springboard_name
      };
      return appBrandingService.createBranding(model).then(function () {
        appBrandingService.logChange(model, {
          type: 'created'
        });
        $scope.navigate("/app/".concat(model.fp_ext_id));
        return $scope.setFlashMessage('Your app has been created.');
      }, function (res) {
        if (res.data && typeof res.data.error === 'string') {
          return alert(res.data.error);
        } else {
          return alert('An error occured. Please try again later.');
        }
      });
    });
  };
  $scope.bulkCreatePublishingRequest = function () {
    var brandings = $scope.selectedBrandings;
    if (!confirm("Are you sure you want to create ".concat(brandings.length, " publishing requests?"))) {
      return;
    }
    var tasks = [];
    var taskNames = [];
    _.each(brandings, function (branding) {
      taskNames.push(branding.fp_ext_id);
      return tasks.push(function () {
        return appBrandingService.createPublishingRequest(branding, {
          silent: true
        });
      });
    });
    var taskSeries = taskSeriesService.createTaskSeries(tasks, taskNames);
    var executor = taskExecutorService.executeTaskSeries(taskSeries);
    return taskExecutorService.openModalWithTaskSeriesProgress(executor, {
      title: 'Creating publishing requests...'
    });
  };
  $scope.bulkStartJobs = function () {
    var brandings = $scope.selectedBrandings;
    return modalService.openModalWithForm({
      title: 'Start jobs',
      fields: FORMS.buildJobs,
      saveLabel: "Start ".concat(brandings.length, " ").concat(pluralizeIfSeveral('job', brandings)),
      formCanBeSaved: function formCanBeSaved(model) {
        return model.type;
      }
    }).then(function (options) {
      var tasks = [];
      var taskNames = [];
      _.each(brandings, function (branding) {
        taskNames.push(branding.fp_ext_id);
        return tasks.push(function () {
          return appBrandingService.buildBranding(branding.fp_ext_id, options);
        });
      });
      var taskSeries = taskSeriesService.createTaskSeries(tasks, taskNames);
      var executor = taskExecutorService.executeTaskSeries(taskSeries);
      return taskExecutorService.openModalWithTaskSeriesProgress(executor, {
        title: 'Starting builds...'
      });
    });
  };
  $scope.bulkUpdateStoreVersions = function () {
    var brandings = $scope.selectedBrandings;
    return modalService.openModalWithForm({
      title: 'Update store versions',
      fields: FORMS.storeVersions,
      model: {},
      saveLabel: "Update ".concat(brandings.length, " ").concat(pluralizeIfSeveral('app', brandings)),
      formCanBeSaved: function formCanBeSaved(model) {
        return model.ios_version || model.android_version;
      }
    }).then(function (updates) {
      _.each(updates, function (value, key) {
        if (_.isEmpty(value)) {
          return delete updates[key];
        }
      });
      var tasks = [];
      var taskNames = [];
      _.each(brandings, function (branding) {
        taskNames.push("Fetching branding ".concat(branding.fp_ext_id));
        tasks.push(function () {
          return appBrandingService.getBranding(branding.fp_ext_id);
        });
        taskNames.push("Updating branding ".concat(branding.fp_ext_id));
        return tasks.push(function (resp) {
          var brandingDoc = resp.data;
          brandingDoc.store = brandingDoc.store || {};
          _.extend(brandingDoc.store, updates);
          return appBrandingService.saveBranding(brandingDoc);
        });
      });
      var taskSeries = taskSeriesService.createTaskSeries(tasks, taskNames);
      var executor = taskExecutorService.executeTaskSeries(taskSeries);
      return taskExecutorService.openModalWithTaskSeriesProgress(executor, {
        title: 'Updating brandings...'
      }).then(function () {
        return $route.reload();
      });
    });
  };
  var loadAccounts = function loadAccounts() {
    if ($scope.canPublishApps) {
      return appBrandingService.getAllPublishingAccounts();
    } else {
      return Promise.resolve({
        data: []
      });
    }
  };
  var loadData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _ref5,
        _ref5$skip,
        skip,
        _ref5$clear,
        clear,
        accountsPromise,
        baseAppPromise,
        pageLimit,
        filters,
        appsPagePromise,
        _yield$Promise$all,
        _yield$Promise$all2,
        accounts,
        appsPage,
        baseApp,
        baseAppAndroidVersion,
        baseAppIosVersion,
        versionsMatch,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _ref5 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref5$skip = _ref5.skip, skip = _ref5$skip === void 0 ? 0 : _ref5$skip, _ref5$clear = _ref5.clear, clear = _ref5$clear === void 0 ? false : _ref5$clear;
            loadDataDebounced.cancel();
            $scope.loading = true;
            if (clear) {
              $scope.tableConfig.currentPage = 1;
            }
            _context2.prev = 4;
            accountsPromise = cachedAccounts ? Promise.resolve(cachedAccounts) : loadAccounts();
            baseAppPromise = cachedBaseApp ? Promise.resolve(cachedBaseApp) : appBrandingService.getBranding('spotme')
            // this is only use to have some versions
            .catch(function () {
              return {
                data: {
                  store: {
                    android_version: '*',
                    ios_version: '*'
                  }
                }
              };
            });
            pageLimit = $scope.tableConfig.itemsByPage; // Enforce it, because `smart-table` component will set 100 when searching
            filters = Object.entries($scope.filters).reduce(function (acc, _ref6) {
              var _ref7 = _slicedToArray(_ref6, 2),
                key = _ref7[0],
                filterObj = _ref7[1];
              acc[key] = filterObj.value;
              return acc;
            }, {});
            appsPagePromise = appBrandingService.findBrandings(_objectSpread({
              skip: skip,
              limit: pageLimit,
              searchTerm: searchTerm
            }, filters));
            _context2.next = 12;
            return Promise.all([accountsPromise, appsPagePromise, baseAppPromise]);
          case 12:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            accounts = _yield$Promise$all2[0];
            appsPage = _yield$Promise$all2[1];
            baseApp = _yield$Promise$all2[2];
            cachedAccounts = accounts;
            cachedBaseApp = baseApp;
            baseAppAndroidVersion = baseApp.data.store.android_version;
            baseAppIosVersion = baseApp.data.store.ios_version;
            versionsMatch = appBrandingService.versionsMatch; // Needed for 1st-time load. When using pagination, `numberOfItems` is returned by this function
            $scope.tableConfig.numberOfItems = appsPage.data.total_count;
            allBrandings = $scope.rowCollection = _.map(_.compact(appsPage.data.apps), function (row) {
              row.info.android_version_is_latest = versionsMatch(row.store.android_version, baseAppAndroidVersion);
              row.info.ios_version_is_latest = versionsMatch(row.store.ios_version, baseAppIosVersion);
              row.info.is_up_to_date = row.info.android_version_is_latest && row.info.ios_version_is_latest;

              // allows users to type id:xyz in search box
              row._search_helper_id = "id:".concat(row.fp_ext_id);
              row._search_helper_name = "aname:".concat(row.springboard_name);
              row._search_helper_store_name = "sname:".concat(row.store_name);
              return row;
            });

            // Return like this for server-side pagination to work (required by smart-table)
            return _context2.abrupt("return", {
              rows: allBrandings,
              numberOfItems: appsPage.data.total_count
            });
          case 25:
            _context2.prev = 25;
            $scope.loading = false;
            return _context2.finish(25);
          case 28:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4,, 25, 28]]);
    }));
    return function loadData() {
      return _ref4.apply(this, arguments);
    };
  }();
  var loadDataDebounced = debounce(loadData, 500);
  loadData();
};
AppsListCtrl.$inject = ["$route", "$scope", "$sanitize", "$q", "$filter", "userService", "modalService", "appBrandingService", "taskSeriesService", "taskExecutorService"];
AppsListCtrl.$inject = ["$route", "$scope", "$sanitize", "$q", "$filter", "userService", "modalService", "appBrandingService", "taskSeriesService", "taskExecutorService"];
angular.module('backstage.controllers.brandedApps').controller('AppsListCtrl', AppsListCtrl);